module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[95]582.6f839bf.woff2";